import { HttpClient, CartApi, Helpers, Mapper, ShopApi, ApiConfig } from '@beef/shop-cart-api';
import Cookies from 'js-cookie';

import { SOURCE_BASKET } from './constants';

export * from '@beef/shop-cart-api';

// export const API_URL = process.env.API_URL?.replace(/\/$/, '') || '/';

const isUAT = Cookies.get('25033DF0F2CA4154B4A00207AE34133D') === 'true';
const isProdLike = Cookies.get('7076AA727B5842549ED302F55EA3D68F') === 'true';

const httpConfig: ApiConfig = {
  // delay: 2000,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    ...(isUAT ? { 'x-api-302eccb3-6d67-498e-8c02-3483f0e6990b': true } : {}),
    ...(isProdLike ? { 'x-api-E6612932-29AE-4617-AC2D-3284E2E465E7': true } : {}),
  },
  // retries: 2,
  withCredentials: true,
};

const cartClient = new HttpClient({
  ...httpConfig,
  baseURL: '/basketapi/',
});

const shopClient = new HttpClient({
  ...httpConfig,
  baseURL: '/shop/',
});

export const headerClient = new HttpClient({
  ...httpConfig,
  baseURL: '/header/',
});

const helpers = new Helpers('', SOURCE_BASKET);
const mapper = new Mapper();

export const cartApi = new CartApi(cartClient, mapper, helpers);
export const api = new ShopApi(shopClient);
